// Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved

// import {Action, IState, INITIAL_STATE} from './store/Store';

// export default function reducer(state: IState = INITIAL_STATE, action: Action) {
//   switch (action.type) {
//     case 'add todo': {
//       return {
//         ...state,
//         lastUpdated: Date.now(),
//         todos: state.todos.concat(action.todo),
//       };
//     }

//     case 'delete todo': {
//       const todos = state.todos.slice();
//       todos.splice(action.index, 1);
//       return {...state, lastUpdated: Date.now(), todos};
//     }

//     default:
//       return state;
//   }
// }


import { Action, ADD_TODO, DELETE_TODO } from '../actions';

export interface IState {
  lastUpdated: number;
  todos: string[];
}


function TodoReducer(state:IState = INITIAL_STATE, action:Action) {
  switch (action.type) {
    case ADD_TODO: {
      return {
        ...state,
        lastUpdated: Date.now(),
        todos: state.todos.concat(action.todo),
      };
    }

    case DELETE_TODO: {
      const todos = state.todos.slice();
      todos.splice(action.index, 1);
      return {...state, lastUpdated: Date.now(), todos};
    }

    default:
      return state;
  }
}


export const INITIAL_STATE: IState = {
  lastUpdated: 0,
  todos: [
    'Make the fire!',
    'Fix the breakfast!',
    'Wash the dishes!',
    'Do the mopping!',
  ],
};


export default TodoReducer;